const COMPLETE_REGISTRATION_STORAGE_KEY =
  "psyassist:meta:complete-registration:sessions";

const trackedRegistrationSessions = new Set();

const isMetaPixelAvailable = () => {
  return (
    typeof window !== "undefined" &&
    typeof window.fbq === "function"
  );
};

const normalizeSessionId = (sessionId) => {
  return String(sessionId || "").trim();
};

const readTrackedRegistrationSessions = () => {
  if (typeof window === "undefined") {
    return [];
  }

  try {
    const raw = window.localStorage.getItem(
      COMPLETE_REGISTRATION_STORAGE_KEY
    );

    if (!raw) {
      return [];
    }

    const parsed = JSON.parse(raw);

    return Array.isArray(parsed)
      ? parsed
          .map((value) => normalizeSessionId(value))
          .filter(Boolean)
      : [];
  } catch {
    return [];
  }
};

const saveTrackedRegistrationSession = (sessionId) => {
  const normalizedSessionId = normalizeSessionId(sessionId);

  if (!normalizedSessionId) {
    return;
  }

  trackedRegistrationSessions.add(normalizedSessionId);

  if (typeof window === "undefined") {
    return;
  }

  try {
    const persistedSessions = readTrackedRegistrationSessions();

    const uniqueSessions = Array.from(
      new Set([
        ...persistedSessions,
        normalizedSessionId,
      ])
    );

    // Mantém apenas as sessões mais recentes para evitar crescimento
    // indefinido do localStorage.
    const limitedSessions = uniqueSessions.slice(-50);

    window.localStorage.setItem(
      COMPLETE_REGISTRATION_STORAGE_KEY,
      JSON.stringify(limitedSessions)
    );
  } catch {
    // Se o localStorage estiver indisponível, a proteção em memória
    // ainda evita duplicidade durante a sessão atual da aplicação.
  }
};

const wasRegistrationSessionTracked = (sessionId) => {
  const normalizedSessionId = normalizeSessionId(sessionId);

  if (!normalizedSessionId) {
    return false;
  }

  if (trackedRegistrationSessions.has(normalizedSessionId)) {
    return true;
  }

  const persistedSessions = readTrackedRegistrationSessions();

  if (persistedSessions.includes(normalizedSessionId)) {
    trackedRegistrationSessions.add(normalizedSessionId);
    return true;
  }

  return false;
};

export const trackPageView = () => {
  if (!isMetaPixelAvailable()) {
    return false;
  }

  window.fbq("track", "PageView");

  return true;
};

export const trackCompleteRegistration = () => {
  if (!isMetaPixelAvailable()) {
    return false;
  }

  window.fbq("track", "CompleteRegistration");

  return true;
};

export const trackCompleteRegistrationOnce = (sessionId) => {
  const normalizedSessionId = normalizeSessionId(sessionId);

  if (!normalizedSessionId) {
    return false;
  }

  if (wasRegistrationSessionTracked(normalizedSessionId)) {
    return false;
  }

  if (!trackCompleteRegistration()) {
    return false;
  }

  saveTrackedRegistrationSession(normalizedSessionId);

  return true;
};
